import {
  getAdStates,
  getAdStatesWithName,
} from 'Selectors';

export const updateAnimationDuration = (adState, duration) => ({
  type: 'UPDATE_ANIMATION_DURATION',
  adState,
  duration,
});

export const updateStartAndEndTime = (adState, startTime, endTime) => ({
  type: 'UPDATE_START_AND_END_TIME',
  adState,
  startTime,
  endTime,
});

export const updateAnimationLoop = (adState, loop) => ({
  type: 'UPDATE_ANIMATION_LOOP',
  adState,
  loop,
});

export const updateAdStateScript = (adState, script) => ({
  type: 'UPDATE_ADSTATE_SCRIPT',
  adState,
  script,
});

export const moveAdState = (adState, rect) =>
  (dispatch, getState) => {
    const valueInRange = (value, min, max) => value >= min && value <= max;

    const doRectsOverlap = (rectA, rectB) => {
      const xOverlap = valueInRange(
        rectA.left,
        rectB.left,
        rectB.left + rectB.width,
      ) || valueInRange(rectB.left, rectA.left, rectA.left + rectA.width);
      const yOverlap = valueInRange(
        rectA.top,
        rectB.top,
        rectB.top + rectB.height,
      ) || valueInRange(rectB.top, rectA.top, rectA.top + rectA.height);
      return xOverlap && yOverlap;
    };

    const overlap = getAdStates(getState())
      .filter(a => a !== adState)
      .reduce(
        (r, a) => r || doRectsOverlap(a.dimensions.toObject(), rect),
        false,
      );

    if (!overlap) {
      dispatch({
        type: 'UPDATE_ADSTATE_DIMENSIONS',
        adState,
        rect,
      });
    }
  };

export const resizeAdState = (adState, rect) =>
  (dispatch) => {
    const newRect = Object.assign({}, adState.dimensions, rect);
    dispatch({
      type: 'UPDATE_ADSTATE_VIEWPORT',
      adState,
      newRect,
    });
  };

export const updateAdStateName = (adState, name) =>
  (dispatch, getState) => {
    if (getAdStatesWithName(getState(), { name }).length < 1) {
      dispatch({
        type: 'UPDATE_ADSTATE_NAME',
        adState,
        name,
      });
    }
  };

export const updateSelectedAdStateName = name => ({
  type: 'UPDATE_SELECTED_ADSTATE_NAME',
  name,
});

export const updateSelectedAdStateDimensions = dimension => ({
  type: 'UPDATE_SELECTED_ADSTATE_DIMENSIONS',
  dimension,
});

export const updateSelectedAdStateViewportSize = size => ({
  type: 'UPDATE_SELECTED_ADSTATE_VIEWPORT_SIZE',
  size,
});

export const updateSelectedAdStateOffsetHeight = size => ({
  type: 'UPDATE_SELECTED_ADSTATE_OFFSET_HEIGHT',
  size,
});

export const updateSelectedAdStateBackgroundColor = backgroundColor => ({
  type: 'UPDATE_SELECTED_ADSTATE_BACKGROUND_COLOR',
  backgroundColor,
});

export const updateSelectedAdStateBorderColor = borderColor => ({
  type: 'UPDATE_SELECTED_ADSTATE_BORDER_COLOR',
  borderColor,
});

export const updateSelectedAdStateBorderWidth = borderWidth => ({
  type: 'UPDATE_SELECTED_ADSTATE_BORDER_WIDTH',
  borderWidth,
});

export const goToTime = time => ({
  type: 'GOTO_TIME',
  time,
});

export const moveTime = ({ deltaT }) => ({
  type: 'MOVE_TIME',
  deltaT,
});

export const deleteSelectedArtboard = () => ({
  type: 'DELETE_SELECTED_ADSTATE',
});

export const addNewArtboard = (artboardName, artboardDimensions, style = {}, script = '') => ({
  type: 'ADD_NEW_ADSTATE',
  artboardName,
  artboardDimensions,
  style,
  script,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/adStateActions.js